import { render, staticRenderFns } from "./podDiaper.vue?vue&type=template&id=13937c94&"
import script from "./podDiaper.vue?vue&type=script&lang=js&"
export * from "./podDiaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports